import { DOWNLOAD_PDF, DOWNLOAD_PDF_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const downloadPdfAction = (params) => async (dispatch) => {
  const { legal_id, order_id } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/download-receipt`,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: DOWNLOAD_PDF,
    });
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: DOWNLOAD_PDF_ERROR,
    });
  }
};
